import {PAUSE_TIMER, RESET_TIMER, RESUME_TIMER, SKIP_TIMER, START_TIMER, STOP_TIMER, TICK_TIMER, TIMER_HAS_EXPIRED} from "./action";
import {AnyAction} from "redux";


/**
 * start the timer
 * @returns {AnyAction}
 */
export function startTimer() : AnyAction
{
    return {type: START_TIMER, payload: {}};
}

/**
 * tick the timer
 * @returns {AnyAction}
 */
export function tickTimer() : AnyAction
{
    return {type: TICK_TIMER, payload: {}};
}


/**
 * stop the timer
 * @returns {AnyAction}
 */
export function stopTimer() : AnyAction
{
    return {type: STOP_TIMER, payload: {}};
}


/**
 * start the timer
 * @returns {AnyAction}
 */
export function pauseTimer() : AnyAction
{
    return {type: PAUSE_TIMER, payload: {}};
}


/**
 * stop the timer
 * @returns {AnyAction}
 */
export function resumeTimer() : AnyAction
{
    return {type: RESUME_TIMER, payload: {}};
}


/**
 * when the game time runs out
 * @returns {AnyAction}
 */
export function timerHasExpired() : AnyAction
{
    return {type: TIMER_HAS_EXPIRED, payload: {}};
}


/**
 * reset the timer
 * @returns {AnyAction}
 */
export function resetTimer() : AnyAction
{
    return {type: RESET_TIMER, payload: {}};
}



// WEBPACK FOOTER //
// ./src/ts/store/actions/timer.ts